import DesignDocsViewer from "../../superAdmin/design/DesignDocsViewer";

const DesignDocsPage = () => {
    return <DesignDocsViewer />;
};

export default DesignDocsPage;
